// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d584990","239":"12ca7d7f","453":"d056b2c3","667":"740e0180"}[chunkId] + ".chunk.js";
};